import { RecordBase } from '../../providers/request/record-base.model';

export class JgLoadInspReportFile extends RecordBase {
  projectId?: number;
  jgSectionId?: number;
  sectionId?: number;
  sectionItemIds?: Array<string | number>;
  fileId?: string;
  fileMd5?: string;
  fileSn?: string;
  fileName?: string;
  uploadTime?: number;
  comment?: string;
}
